<template>
  <ValidationProvider
    :ref="validationProviderRef"
    :mode="veeValidateInteractionMode"
    :rules="validationRules"
    :vid="validationProviderRef"
    :debounce="validationDelay"
    :name="label"
    :immediate="true"
  >
    <div
      slot-scope="{ validate, errors }"
      :data-cy="datacy"
    >
      <v-select
        :id="validationProviderRef"
        v-model="mutableValue"
        :errorMessages="errors"
        :label="displayedLabel"
        :items="items"
        :itemText="itemText"
        :itemValue="itemValue"
        :class="extraClass"
        :required="isRequired"
        :hideDetails="hideDetails"
        v-bind="$attrs"
        :disabled="disabled"
        v-on="$listeners"
        @change="$emit('input', mutableValue)"
      >
        <template v-slot:item="{ item }">
          <span
            :data-cy="prepareNameForCypress(`type-${item.name || item }`)"
            class="v-select-item v-list-item__title"
          >
            {{ item.name || item }}
          </span>
        </template>
      </v-select>
      <SlotScopeWatcher
        :value="mutableValue"
        @change="(!isFirstValue || validateAtInitialization) && validate(mutableValue)"
      />
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';
import _, { cloneDeep } from 'lodash';


export default {
    name: 'Select',
    components: {
        SlotScopeWatcher,
        ValidationProvider,
    },
    mixins: [
        validationProviderHelperMixin,
    ],
    props: {
        label: {
            type: String,
            default: '',
        },
        extraClass: {
            type: String,
            default: null,
        },
        hideDetails: {
            type: [String, Boolean],
            default: false,
        },
        items: {
            type: Array,
            default: () => [],
        },
        value: {
            type: [Object, String, Array, Number],
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        itemText: {
            type: [String, Function],
            default: 'name',
        },
        itemValue: {
            type: String,
            default: 'id',
        },
        validateAtInitialization: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Object,
            default: () => ({}),
        },
        datacy: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isFirstValue: true,
            mutableValue: this.value,
            validationRules: { required: this.required, ...this.rules },
        };
    },
    computed: {
        displayedLabel() {
            return `${this.label} ${this.validationRules.required ? '*' : ''}`;
        },
        isRequired() {
            return this.required;
        },
    },
    watch: {
        value() {
            this.isFirstValue = false;
            this.mutableValue = this.value;
        },
    },
    methods: {
        /* Delete Spaces to avoid error in Cypress */
        prepareNameForCypress(nameItem) {
            const name = cloneDeep(nameItem);
            return _.replace(name, /\s/g, '');
        },
    },
};
</script>
